import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const index = r => require.ensure([], () => r(require('@/pages/index')), 'index');
const details = r => require.ensure([], () => r(require('@/pages/details')), 'details');
const routes = [
  {path: '/', redirect: '/index', meta: {title: '华夏青少年服务平台'}},
  {path: '/index', component: index, meta: {title: '华夏青少年服务平台'}},
  {path: '/details/:id', component: details, meta: {title: '华夏青少年服务平台'}},
];
const router = new Router({
  mode: 'history',
  routes
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js